import { Input } from "@material-tailwind/react";

export function InputForDarkSurface() {
  return (
    <div className="w-72">
      <Input type="email" color="white" label="Email Address" />
    </div>
  );
}
